import tw from "twin.macro"
import { useState } from "react"
import useOpenAI, { allModes, CHAT_BOT } from "../hooks/useOpenAI"
import PageBase from "../components/PageBase"

export default function OpenAIText() {
  const [mode, setMode] = useState(CHAT_BOT)
  const [text, setText] = useState("")
  const { response, error, loading, generate, resetMemory } = useOpenAI(mode)

  const handleEnter = e => e.key === "Enter" && handleGenerateText()
  const handleChange = e => setText(e.target.value)
  const handleGenerateText = () => {
    if (!text) return
    generate(text)
    setText("")
  }

  const openAI = { response, error, loading, resetMemory }

  return (
    <PageBase title="Chat AI" openAI={openAI}>
      <ModesWrapper>
        {allModes.map(mode => (
          <button onClick={() => setMode(mode)}>{mode}</button>
        ))}
      </ModesWrapper>
      <Input
        onKeyDown={handleEnter}
        type="text"
        placeholder="Chat with me..."
        value={text}
        onChange={handleChange}
      />
      <Button onClick={handleGenerateText}>Generate Response</Button>
    </PageBase>
  )
}

const ModesWrapper = tw.div`flex gap-4 justify-center`
const Input = tw.input`mx-auto w-full max-w-[24rem] h-10 px-4 text-gray-900 rounded-lg border-2 border-neutral-700 focus:outline-none focus:border-neutral-600`
const Button = tw.button`mx-auto w-full max-w-[24rem] h-10 rounded-lg bg-neutral-700 hover:bg-neutral-600 text-white font-bold`
